import ProductFilter from "./product-filter";
import ProductList from "./product-list";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {setToolsInitialState} from "../../reducers/tools.reducer";
import {setProductSelectedRowKeys} from "../../reducers/product.reducer";
import {SORT_LIST_PRODUCT} from "../../utils/sort-list";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";

const ProductPage = () => {
    const dispatch = useDispatch()
    const defaultSort = SORT_LIST_PRODUCT.find(item => item.isDefault)
    const getOrderBy = defaultSort?.key.split('_')
    const {
        currentPage,
        pageSize,
        orderBy,
        sort,
        searchKey,
        filter,
        reload
    } = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        orderBy: !!orderBy ? orderBy : getOrderBy[0],
        orderType: sort,
        search: searchKey,
        filterByCategory: filter['category'] ?? [],
        filterByStatus: filter['status'] ?? []
    }
    const {
        data: response,
        fetching: getProductList,
        isLoading
    } = useFetch(API.PRODUCT_LIST, queryParams, {isWithTotalData: true})

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
            dispatch(setProductSelectedRowKeys([]))
        }
    }, [])

    useEffectAfterMount(() => {
        getProductList()
    }, [currentPage, pageSize, orderBy, sort, searchKey, filter, reload])

    return (
        <div className={"col px-10"}>
            <ProductFilter lastSync={response?.data?.last_sync ?? ''}/>
            <ProductList datasource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default ProductPage
